import { Injectable } from '@angular/core';

import { credentials, endpoints, environment, formats, settings } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  constructor() {}

  get environment() {
    return environment;
  }

  get formats() {
    return formats;
  }

  get endpoints() {
    return endpoints;
  }

  get credentials() {
    return credentials;
  }

  get settings() {
    return settings;
  }

  get dateFormat(): string {
    return this.formats.dateFormat;
  }

  get dateLongFormat(): string {
    return this.formats.dateLongFormat;
  }

  get dateTimeFormat(): string {
    return this.formats.dateTimeFormat;
  }

  get dateTimeLongFormat(): string {
    return this.formats.dateTimeLongFormat;
  }

  get dateTimeSecondsFormat(): string {
    return this.formats.dateTimeSecondsFormat;
  }

  get dateTimeSecondsLongFormat(): string {
    return this.formats.dateTimeSecondsLongFormat;
  }

  get dateTime24Format(): string {
    return this.formats.dateTime24Format;
  }

  get dateTime24LongFormat(): string {
    return this.formats.dateTime24LongFormat;
  }

  get dateTime24SecondsFormat(): string {
    return this.formats.dateTime24SecondsFormat;
  }

  get dateTime24SecondsLongFormat(): string {
    return this.formats.dateTime24SecondsLongFormat;
  }

  get timeFormat(): string {
    return this.formats.timeFormat;
  }

  get timeFormatLong(): string {
    return this.formats.timeFormatLong;
  }

  get time24Format(): string {
    return this.formats.time24Format;
  }

  get time24FormatLong(): string {
    return this.formats.time24FormatLong;
  }

  get primeNgDateFormat(): string {
    return this.formats.primeNgDateFormat;
  }

  get primeNgDateLongFormat(): string {
    return this.formats.primeNgDateLongFormat;
  }

  get primeNgTime12Format(): string {
    return this.formats.primeNgTime12Format;
  }

  get primeNgTime24Format(): string {
    return this.formats.primeNgTime24Format;
  }
}
